if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          /* Error first. The previous version opened the drawer BEFORE
             checking response.status, so a failed add still popped an
             unchanged drawer at the customer. */
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          /* Rebuild the cart through ajaxCart rather than simulating a click
             on .js-drawer-open-right.

             ajaxCart.load() fetches /cart.js, re-renders the drawer contents,
             and fires afterCartLoad.ajaxCart, which is the event theme.liquid
             listens on to call mono.RightDrawer.open(). So the drawer opens
             WITH fresh contents.

             The old click-trigger did neither: it never refreshed the line
             items, and mono.Drawers.open() treats a real click as a toggle
             (`if (this.drawerIsOpen && !externalCall) return this.close()`),
             so adding a second item while the drawer was open closed it. */
          if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
            window.ajaxCart.load();
          } else if (window.mono && mono.RightDrawer) {
            mono.RightDrawer.open();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
